export default __webpack_public_path__ + "static/media/resources-for-you-illustration.ecd172a9.png";